import React, { useState, useEffect } from 'react'
import {
    Breadcrumbs,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    TextField,
    LinearProgress,
    Link as MLink,
    Snackbar,
    Tooltip,
    Typography
} from '@material-ui/core'
import Table from '../../../components/Table'
import axios from 'axios'
import { apiDelete, apiGet, apiPost } from '../../../functionsAPI'
import { API_URL, CODE_DEBUG } from '../../../config'
import AddIcon from '@material-ui/icons/Add'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import SettingsIcon from '@material-ui/icons/Settings';
import VpnKeyIcon from '@material-ui/icons/VpnKey'
import { Link } from 'react-router-dom'
import MuiAlert from '@material-ui/lab/Alert'
import { Autocomplete } from '@material-ui/lab'

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
}

const ListUsers = (props) => {
    const [tableData, setTableData] = useState([])
    const [count, setCount] = useState(0)
    const [start, setStart] = useState(0)
    const [limit, setLimit] = useState(10)
    const [sortBy, setSortBy] = useState('all')
    const [order, setOrder] = useState('all')
    const [search, setSearch] = useState('all')
    const [showAlert, setShowAlert] = useState(false)
    const [alertType, setAlertType] = useState('success')
    const [alertMessage, setAlertMessage] = useState(null)
    const token = localStorage.getItem('tgToken')
    const [open, setOpen] = useState(false)
    const [userId, setUserId] = useState(null)
    const [loading, setLoading] = useState(false)
    const [openAdditionalInfo, setOpenAdditionalInfo] = useState(false);
    const [plants,setPlants] = useState([])
    const [plant,setPlant] = useState(null)
    const [assignedPlants,setAssignedPlants] = useState([])

    const columns = [
        {
            name: "#",
            label: "#",
            options: {
                sort: false,
                customBodyRenderLite: (rowIndex) => {
                    return start + rowIndex + 1
                }
            }
        },
        {
            name: "first_name",
            label: "First Name",
            options: {
                sort: true,
            }
        },
        {
            name: "last_name",
            label: "Last Name",
            options: {
                sort: true,
            }
        },
        {
            name: "email",
            label: "Email",
            options: {
                sort: true,
            }
        },
        {
            name: "role",
            label: "Role",
            options: {
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return value.name
                }
            }
        },
        {
            name: "action",
            label: "Action",
            options: {
                sort: false,
            }
        }
    ]

    const getList = (start = 0, limit = 10, sortBy = 'all', order = 'all', search = 'all') => {
        const params = {
            sort_by: sortBy,
            order,
            start,
            limit,
            search
        }
        const headerConfig = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                token
            },
            params
        }
        const url = API_URL + '/users'
        axios.get(url, headerConfig).then(response => {
            response.data.list.map(user => {
                var action = ''
                const editUrl = 'users/' + user.id
                const resetPasswordUrl = 'users/reset-password/' + user.id
                const emailUrl = 'mailto:' + user.email
                const email = (
                    <Tooltip title="Send Email">
                        <MLink href={emailUrl} className="link" color="inherit">
                            {user.email}
                        </MLink>
                    </Tooltip>
                )
                if (user.role.editable === true) {
                    action = (
                        <div>
                            <Link to={editUrl}>
                                <Tooltip title="Edit User">
                                    <IconButton>
                                        <EditIcon />
                                    </IconButton>
                                </Tooltip>
                            </Link>
                            <Link to={resetPasswordUrl}>
                                <Tooltip title="Reset Password">
                                    <IconButton>
                                        <VpnKeyIcon />
                                    </IconButton>
                                </Tooltip>
                            </Link>
                            <Tooltip title="Delete User">
                                <IconButton onClick={() => handleClickOpen(user.id)}>
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Plants">
                                <IconButton onClick={() => handleAdditionalInfoOpen(user.id)}>
                                    <SettingsIcon />
                                </IconButton>
                            </Tooltip>
                        </div>
                    )
                } else {
                    action = ''
                }
                user.email = email
                user.action = action
                return true
            })
            setCount(response.data.count)
            setTableData(response.data.list)
        }).catch(error => {
            if (error.response) {
                if (error.response.status === 401) {
                    setAlertType('error')
                    setAlertMessage(error.response.data.detail)
                    setShowAlert(true)
                }
                CODE_DEBUG && console.log(error.response)
            } else if (error.request) {
                CODE_DEBUG && console.log(error.request)
            } else {
                CODE_DEBUG && console.log(error)
            }
        })
    }

    const getPlants = () => {
        const url = '/plant/all'
        apiGet(url).then(response => {
                setPlants(response.data)
            })
            .catch(error => {
                setAlertType('error')
                setAlertMessage(error)
                setShowAlert(true)
            })
    }

    useEffect(() => {
        getList()
        // eslint-disable-next-line
    }, [])

    const getAssignedPlants = (id) => {
        setLoading(true)
        const url =  `/users/${id}/user-plant`
        apiGet(url)
            .then((response) => {
                setAssignedPlants(response.data)
                setLoading(false)
            })
            .catch(error => {
                setAlertType('error')
                setAlertMessage(error)
                setShowAlert(true)
                setLoading(false)
            })
    }
    const handleAdditionalInfoOpen = (id) => {
        setUserId(id)
        getPlants()
        getAssignedPlants(id)
        setOpenAdditionalInfo(true);
    };

    const handleAddPlant = () => {
        setLoading(true)
        if (plant) {
            const data = {
                plant_id: plant.id,
            }
            const url = `/users/${userId}/user-plant`
            apiPost(url, data)
                .then((res) => {
                    setAlertType('success')
                    setAlertMessage('Added successfully')
                    setShowAlert(true)
                    setLoading(false)
                    setPlant(null)
                    getAssignedPlants(userId)
                })
                .catch(error => {
                    setAlertType('error')
                    setAlertMessage(error)
                    setShowAlert(true)
                    setLoading(false)
                })
        } else {
            setAlertType('error')
            setAlertMessage('Please select Plant')
            setShowAlert(true)
            setLoading(false)
        }
    }

    // Clearing up used states
    const handleAdditionalInfoClose = () => {
        setOpenAdditionalInfo(false);
        setPlant(null)
    };

    // Delete User Plant
    const deleteUserPlant = (id) => {
        setLoading(true)
        const url =  `/users/${userId}/user-plant/${id}`
        apiDelete(url)
            .then((res) => {
                setAlertType('success')
                setAlertMessage('Deleted successfully')
                setShowAlert(true)
                getAssignedPlants(userId)
                setLoading(false)
            })
            .catch(error => {
                setAlertType('error')
                setAlertMessage(error)
                setShowAlert(true)
                setLoading(false)
            })
    }

    const changePage = (page) => {
        const start = limit * (page)
        getList(start, limit, sortBy, order, search)
        setStart(start)
    }

    const sort = (sortOrder) => {
        const sortBy = sortOrder.name
        const order = sortOrder.direction
        getList(start, limit, sortBy, order, search)
        setSortBy(sortBy)
        setOrder(order)
    }

    const changeRowsPerPage = (limit) => {
        getList(start, limit, sortBy, order, search)
        setLimit(limit)
    }

    const onSearch = (search) => {
        getList(start, limit, sortBy, order, search)
        setSearch(search)
    }

    const handleTableChange = (action, tableState) => {
        switch (action) {
            case 'changePage':
                changePage(tableState.page)
                break
            case 'sort':
                sort(tableState.sortOrder)
                break
            case 'changeRowsPerPage':
                changeRowsPerPage(tableState.rowsPerPage)
                break
            case 'search':
                const search = (tableState.searchText === null) ? 'all' : tableState.searchText
                onSearch(search)
                break
            default:
        }
    }

    const deleteUser = (userId) => {
        const headerConfig = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                token
            }
        }
        const url = API_URL + '/users/' + userId
        axios.delete(url, headerConfig).then(response => {
            setAlertType('success')
            setAlertMessage('User Deleted.')
            setShowAlert(true)
            setOpen(false)
            getList()
        }).catch(error => {
            let message
            if (error.response) {
                if (error.response.status === 401) {
                    message = error.response.data.detail
                }
                else {
                    message = 'Try after some time.'
                }
                CODE_DEBUG && console.log(error.response)
            } else if (error.request) {
                CODE_DEBUG && console.log(error.request)
                message = 'Try after some time.'
            } else {
                CODE_DEBUG && console.log(error)
                message = 'Try after some time.'
            }
            setAlertType('error')
            setAlertMessage(message)
            setShowAlert(true)
        })
    }

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShowAlert(false);
    }

    const handleClickOpen = (userId) => {
        setOpen(true)
        setUserId(userId)
    }

    const handleClose = () => {
        setOpen(false)
        setUserId(null)
    }

    const progress = loading ? (<LinearProgress />) : ('')

    return (
        <div>
            <Grid container
                direction="row"
                justify="space-between"
                alignItems="flex-start"
            >
                <Grid item >
                    <Breadcrumbs aria-label="breadcrumb">
                        <MLink color="inherit" href="/#/dashboard">
                            Dashboard
                        </MLink>
                        <Typography color="textPrimary">Users</Typography>
                    </Breadcrumbs>
                </Grid>
                <Grid item >
                    <Link to="users/add"><Button variant="contained" color="primary" startIcon={<AddIcon />}>Add User</Button></Link>
                </Grid>
            </Grid>
            <br />
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={showAlert}
                autoHideDuration={5000}
                onClose={handleAlertClose}
            >
                <Alert onClose={handleAlertClose} severity={alertType}>
                    {alertMessage}
                </Alert>
            </Snackbar>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Delete User"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete the User ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="outlined" autoFocus>
                        Cancel
                    </Button>
                    <Button onClick={() => deleteUser(userId)} variant="outlined">
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            {/* additional info */}
            <Dialog open={openAdditionalInfo} onClose={handleAdditionalInfoClose} className="form-action" aria-labelledby="form-dialog-title">
                {progress}
                <DialogTitle id="form-dialog-title">Additional Details</DialogTitle>
                <DialogContent dividers>
                    {/* add item for desh */}
                    <Grid 
                        container
                        spacing={3}
                        direction="row">

                        <Grid item xs={8}>
                            <Autocomplete
                                options={plants}
                                autoHighlight
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => <TextField {...params} label="Plant" required variant="outlined" />}
                                onChange={(e,value)=> {setPlant(value)}}
                                value={plant}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Button
                                variant="contained"
                                color="primary"
                                className='mt-2'
                                onClick={handleAddPlant}
                            >
                                Add Plant
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <table className='userAdditionalDetails' style={{border:'1px solid white',width:'100%',}}>
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Plant Name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {assignedPlants.map((plant, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{plant.plant.name ? plant.plant.name : "" }</td>
                                            <td><IconButton onClick={() => deleteUserPlant(plant.id)}><DeleteIcon /></IconButton></td>
                                        </tr>
                                    )) }
                                </tbody>
                            </table>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAdditionalInfoClose} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Table
                title={'List Users'}
                serverSide={true}
                count={count}
                columns={columns}
                data={tableData}
                onTableChange={handleTableChange}
                rowsPerPage={limit}
            />
        </div>
    )
}

export default ListUsers
